import { createStore, stateSetterHandler } from '@muvi/react-common';
import { isDevtoolsEnabled } from '@/logic/state/store-devtools';

import { CityModel } from '../../services';

export type CitiesState = {
  cities: {
    citiesList: CityModel[];
  };
};

const initState: CitiesState = {
  cities: {
    citiesList: [],
  },
};

export const useCities = createStore({
  name: 'cities',
  devtools: isDevtoolsEnabled,
  persist: false,
})(initState, set => {
  const handler = stateSetterHandler(set);
  return {
    setCities: handler('cities'),
  };
});
